import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

interface ModalTextProps {
  show: boolean;
  onHide: () => void;
  bodyText: string| TrustedHTML;
  headerModalText: string|undefined;
}

const ModalText: React.FC<ModalTextProps> = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props.headerModalText}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <div dangerouslySetInnerHTML={{ __html: props.bodyText }} />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Fermer</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalText;
